import { ConfigInterface } from '@ui-core/interfaces/config.interface'

export const environment: ConfigInterface =
    (window as unknown as { UI_ENV: ConfigInterface }).UI_ENV ||
    (() => {
        console.warn('UI_ENV not found on window. Attempting to load from env.js file...')

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        require('../../public/env.js')

        return (window as unknown as { UI_ENV: ConfigInterface }).UI_ENV
    })()
